/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Faq_Size_Limit_QuestionInputs */

const en_mobile_faq_size_limit_question = /** @type {(inputs: Mobile_Faq_Size_Limit_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is there a size limit for the documents I want to upload?`)
};

const es_mobile_faq_size_limit_question = /** @type {(inputs: Mobile_Faq_Size_Limit_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Hay un límite de tamaño para los documentos que quiero subir?`)
};

/**
* | output |
* | --- |
* | "Is there a size limit for the documents I want to upload?" |
*
* @param {Mobile_Faq_Size_Limit_QuestionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_faq_size_limit_question = /** @type {((inputs?: Mobile_Faq_Size_Limit_QuestionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Faq_Size_Limit_QuestionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_faq_size_limit_question(inputs)
	return en_mobile_faq_size_limit_question(inputs)
});